import { Breakpoints } from '@/common/theme/constants';
import { SxProps } from '@mui/material';

export const styledStepContentCardsWrapper: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  my: '30px',
  width: '100%',

  [`@media (min-width:${Breakpoints.sm + 1}px)`]: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
};

export const styledItemCard: SxProps = {
  width: '100%',
  minWidth: 'none',
  maxWidth: '100%',

  [`@media (min-width:${Breakpoints.sm + 1}px)`]: {
    minWidth: '260px',
    maxWidth: '260px',
  },
};

export const styledContentBox: SxProps = {
  minHeight: '100vh',
  pt: '1rem',
};

export const styledWorkoutDiscountPickerWrapper: SxProps = {
  display: 'flex',
  justifyContent: 'flex-start',
  marginY: '10px',
};

export const styledTermsNoValidDataWrapper: SxProps = {
  ...styledStepContentCardsWrapper,
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '220px',
  px: 3,
  textAlign: 'center',
};
